import {
  SvgCreditCard,
  SvgHeart,
  SvgHome,
  SvgPiggyBank,
  SvgShield,
  SvgTarget,
  SvgTravelCar,
  SvgWallet,
} from '@actual-app/components/icons/v1';
import { SvgSun } from '@actual-app/components/icons/v2';
import type { TFunction } from 'i18next';

import type { PlanningGoalKind } from '#planning/types';

export const planningGoalKinds: PlanningGoalKind[] = [
  'emergency-fund',
  'reserve',
  'sinking-fund',
  'car',
  'vacation',
  'home',
  'wedding',
  'loan-payoff',
  'custom',
];

export function getPlanningGoalLabel(kind: PlanningGoalKind, t: TFunction) {
  switch (kind) {
    case 'emergency-fund':
      return t('Emergency Fund');
    case 'reserve':
      return t('Reserve');
    case 'sinking-fund':
      return t('Sinking Fund');
    case 'car':
      return t('Car');
    case 'vacation':
      return t('Vacation');
    case 'home':
      return t('Home');
    case 'wedding':
      return t('Wedding');
    case 'loan-payoff':
      return t('Loan Payoff');
    case 'custom':
      return t('Custom');
  }
}

export function getPlanningGoalIcon(kind: PlanningGoalKind) {
  switch (kind) {
    case 'emergency-fund':
      return SvgPiggyBank;
    case 'reserve':
      return SvgShield;
    case 'sinking-fund':
      return SvgWallet;
    case 'car':
      return SvgTravelCar;
    case 'vacation':
      return SvgSun;
    case 'home':
      return SvgHome;
    case 'wedding':
      return SvgHeart;
    case 'loan-payoff':
      return SvgCreditCard;
    case 'custom':
      return SvgTarget;
  }
}
